<template>
<!--  导入设备-->
  <div class="advanced-form">
    <div class="card">
      <div class="card-head">
        <h3>下载模板，导入数据</h3>
      </div>
      <div class="card-body">
        <a-button @click="downTemplate" type="primary">下载模板</a-button>

        <p :style="{marginTop: '20px', lineHeight: '25px'}">
          当前设备类型若为门禁设备时，设备名称为非必填项
        </p>
      </div>
    </div>

    <div class="card">
      <div class="card-head">
        <h3>选择要导入的采集系统名称，设置选项后上传</h3>
      </div>
      <div class="card-body">
        <x-addEdit
          ref="addEdit"
          :style="{width: '500px'}"
          :reqLoading="btnLoading"
          :itemLayout="itemLayout"
          :formList="formList"
          :addParam="addParam"
        >
        </x-addEdit>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'importDev',
  mixins: [fetchSelect],
  data () {
    return {
      btnLoading: { loading: false },
      itemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 15 }
      },
      formList: [
        {
          label: '城市',
          inputType: 'cascader',
          options: [],
          handle: this.cityChange,
          placeholder: '请选择城市',
          props: ['areasList', {
            rules: [{required: true, message: '请选择城市'}]
          }]
        },
        {
          label: '系统名称',
          inputType: 'select',
          options: [],
          handle: '',
          placeholder: '',
          props: ['csId', {
            rules: [{required: true, message: '请选择系统名称'}]
          }]
        },
        {
          label: '设备类型',
          inputType: 'select',
          options: [],
          handle: '',
          placeholder: '请选择设备类型',
          props: ['deviceType', {
            rules: [{required: true, message: '请选择设备类型'}]
          }]
        },
        {
          label: '设备数据',
          inputType: 'upload',
          options: [],
          handle: '',
          placeholder: '',
          fileList: [],
          uploadParam: {
            iconUrl: '',
            accept: this.$store.state.excelAccept
          },
          beforeHandle: this.uploadHandle,
          props: ['file', {
            rules: [{required: true, message: '请上传设备数据'}]
          }]
        }
      ],
      formKey: {
        areasList: undefined,
        csId: undefined,
        deviceType: undefined,
        deviceName: undefined,
        upload: undefined
      },
      addParam: {
        url: '',
        reqHandle: this.addReqHandle,
        resHandle: '' // this.addResHandle
      }
    };
  },
  created () {
    this.getSelect();
  },
  methods: {
    getSelect () {
      this.provinceCitySelect(data => {
        this.formList[0].options = data;
      });

      this.$get({
        url: '/coll/device/getDeviceType'
      }).then(({ data }) => {
        this.formList[2].options = data;
      });
    },
    /** 城市 change 事件 */
    cityChange (val) {
      let id = val && val.length ? Number(val[1]) : undefined;
      if (!id) {
        this.$refs.addEdit.resetSubValue(['csId']);
        return;
      }

      this.$get({
        url: '/coll/device/getAddCollSystem',
        params: { cityId: id }
      }).then(({ data }) => {
        this.formList[1].options = data;
      });
    },
    /** 自定义 beforeUpload */
    uploadHandle (file) {
      this.fileData = file;

      this.formList[3].fileList = [{
        uid: file.uid,
        name: file.name,
        url: URL.createObjectURL(file)
      }];
    },
    addReqHandle (values) {
      let formData = new FormData();
      for (let item in values) {
        formData.set(item, values[item]);
      }
      formData.set('file', this.fileData);

      this.$post({
        url: '/coll/device/import',
        params: formData,
        btnLoading: this.btnLoading
      }).then(res => {
        this.$message.success(h => h({
          template: `<div>${res.msg}</div>`
        }));
        this.$refs.addEdit.form.resetFields();
        this.formList[3].fileList = [];
        this.$store.dispatch('delCachedRoute', 'collectDevice');
        this.$router.go(-1);
      });
    },
    downTemplate () {
      window.open(process.env.VUE_APP_BASE_API + '/coll/device/download');
    },
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
